import Vue from 'vue'
import Vuex from 'vuex'
// import loading from './loading.js'
import user from './user.js'
import course from './course.js'
import cart from './cart.js'
import banner from './banner.js'
import transaction from './transaction.js'
import category from './category.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentMenu: '',
    sidebarIsExpanded: true,
    refCount: 0,
    isLoading: false,
    searchCourse: null,
    isMobileView: false,
    isTabletView: false,
  },
  mutations: {
    SET_STATE(state, payload) {
      Object.assign(state, {
        ...payload,
      })
    },
  },
  actions: {
    LOADING({ commit, state }, isLoading) {
      if (isLoading) {
        state.refCount++
        commit('SET_STATE', { isLoading: true })
        // NProgress.start()
        // state.isLoading = true

        // NProgress.start()
      } else if (state.refCount > 0) {
        state.refCount--
        commit('SET_STATE', { isLoading: false })
        // state.isLoading = (state.refCount > 0)
        // NProgress.done()
      }
    },
  },
  modules: {
    // loading,
    user,
    cart,
    course,
    banner,
    transaction,
    category,
  },
  getters: {
    isDesktopView(state) { return !state.isMobileView && !state.isTabletView },
  },
})
